import React from "react";
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
import FAQ from "../components/FAQ";
import "../styles/Home.css";
import EpcServicesGrid from "../components/EpcServicesGrid";
import HeroBackgroundSlideshow from "../components/HeroBackgroundSlideshow";

const Home = () => {

  /* ================= HERO IMAGES =================
     👉 Replace these URLs with YOUR OWN PHOTOS
  ================================================== */

  const heroImages = [
    '/assets/home_img/home1.jpeg',
    '/assets/home_img/home2.jpeg',
    '/assets/home_img/home3.jpeg',
    '/assets/home_img/home4.jpeg',
    '/assets/home_img/home5.jpeg',
    '/assets/home_img/home6.jpeg',
    '/assets/home_img/home7.jpeg',
    '/assets/home_img/home8.jpeg',
    '/assets/home_img/home9.jpeg',
    '/assets/home_img/home10.jpeg',
    '/assets/home_img/home11.jpeg',
    '/assets/home_img/home12.jpeg',
    '/assets/home_img/home13.jpeg',
    '/assets/home_img/home14.jpeg',
    '/assets/home_img/home15.jpeg',
    '/assets/home_img/home16.jpeg',
    '/assets/home_img/home17.jpeg',
    '/assets/home_img/home18.jpeg',
    '/assets/home_img/home19.jpeg',
    '/assets/home_img/home20.jpeg',
  ];
  /* ================= ANIMATIONS ================= */

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0 }
  };

  const faqs = [
    {
      question: "What is solar energy and how does it work?",
      answer: "Solar energy is radiant light and heat from the sun that is harnessed using a range of ever-evolving technologies such as solar heating, photovoltaics, solar thermal energy, solar architecture, molten salt power plants and artificial photosynthesis."
    },
    {
      question: "How much can I save with solar panels?",
      answer: "Savings from solar panels vary based on your location, energy consumption, and local electricity rates. On average, homeowners can save between 40-60% on their electricity bills, with payback periods typically ranging from 5-7 years."
    },
    {
      question: "What are the different types of solar panels?",
      answer: "The main types of solar panels are monocrystalline, polycrystalline, and thin-film. Monocrystalline panels are the most efficient and expensive, while polycrystalline offer good efficiency at a lower cost. Thin-film panels are flexible but less efficient."
    },
    {
      question: "How long do solar panels last?",
      answer: "Most solar panels come with a 25-year warranty and can last 30-40 years with proper maintenance. They typically degrade at a rate of about 0.5% per year, meaning they'll still produce about 80-90% of their original output after 25 years."
    },
    {
      question: "What maintenance do solar panels require?",
      answer: "Solar panels require minimal maintenance. Regular cleaning to remove dust and debris, annual inspections to check for damage, and monitoring system performance are typically sufficient. Most systems don't require any moving parts maintenance."
    },
    {
      question: "Can I install solar panels myself?",
      answer: "While DIY installation is possible, it's not recommended for most homeowners. Professional installation ensures safety, proper wiring, compliance with local codes, and eligibility for warranties and incentives."
    },
    {
      question: "What happens during power outages?",
      answer: "Standard grid-tied solar systems shut down during power outages for safety reasons. However, with battery storage or a hybrid inverter, you can have backup power during outages while still being connected to the grid."
    },
    {
      question: "Are there government incentives for solar?",
      answer: "Yes, there are various government incentives including tax credits, rebates, and net metering programs. The PM Surya Ghar Yojana and other state-specific schemes can significantly reduce the upfront cost of solar installation."
    }
  ];

  const epcServices = [
    { icon: "🔍", text: "Site Assessment", points: ["Detailed site survey", "Shadow analysis and energy assessment", "System feasibility study"] },
    { icon: "📐", text: "System Engineering & Design", points: ["Customized engineering solutions", "Performance optimization", "Safety compliance design"] },
    { icon: "📦", text: "Component Procurement", points: ["High-quality solar equipment", "Tier-1 components", "Warranty coverage"] },
    { icon: "🔧", text: "System Installation", points: ["Professional installation", "Safety compliance", "Quality workmanship"] },
    { icon: "✅", text: "Testing & Commissioning", points: ["Complete system verification", "Performance testing", "Grid connection testing"] },
    { icon: "🛠️", text: "Operation & Maintenance", points: ["Long-term performance monitoring", "Preventive maintenance", "24/7 support"] },
    { icon: "📄", text: "Net Metering Support", points: ["Grid connection assistance", "Regulatory compliance", "Documentation support"] },
    { icon: "💰", text: "Financing Options", points: ["EMI and financing assistance", "Flexible payment plans", "Government subsidy support"] },
  ];

  return (
    <div className="home">

      {/* ================= HERO ================= */}  
      <section
        className="hero"
      >
        <HeroBackgroundSlideshow images={heroImages} />
        {/* <div className="floating-solar">
  <img src="/assets/images/sch.jpeg" className="solar s1" />
  <img src="/assets/images/sch.jpeg" className="solar s2" />
  <img src="/assets/images/sch.jpeg" className="solar s3" />
</div> */}

        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
        >
          <h1>
            Start Your Solar Journey with
            <span className="hero-highlight"> V SQUARE RENEWABLES</span>
          </h1>
          

          <div className="hero-quote">
 <blockquote >
  “Empowering Your Future with Sustainable Energy Solution.”
</blockquote>

  <p className="hero-description">
    We design and deliver high-performance solar power systems that help organizations
    reduce electricity costs while transitioning toward sustainable energy.
  </p>

  <div className="hero-services">
  <Link to="/services/residential-solar">Residential</Link>
  <span className="dot"></span>
  <Link to="/services/commercial-solar">Commercial</Link>
  <span className="dot"></span>
  <Link to="/services/industrial-solar">Industrial</Link>
</div>
</div>

          <div className="hero-buttons">
            <Link className="hero-btn primary" to="/contact">Get a Free Quote</Link>
            <Link className="hero-btn primary" to="/solar-calculator">Calculate Savings</Link>
          </div>
        </motion.div>
      </section>


      {/* ================= SERVICES ================= */}
     

 <section className="services-preview premium-services">

  <div className="section-header">
    <h2 style={{ borderBottom: '3px solid #2E8B57', display: 'inline-block' }}>Our Services</h2>
    <p>
     We provide complete Engineering, Procurement, and Construction (EPC) services for rooftop solar installations. From initial
feasibility analysis to long-term maintenance, V Square Renewables provides end-to-end solar solutions with engineering
excellence and transparent execution at every step.
    </p>
  </div>

  {/* EPC DETAILS */}

   <EpcServicesGrid services={epcServices} />


  {/* PREMIUM SERVICE CARDS */}

  <div className="premium-grid">

    <Link to="/services/residential-solar" className="service-card-link">
      <motion.div
        className="premium-card"
        initial={{ opacity:0, y:60 }}
        whileInView={{ opacity:1, y:0 }}
        whileHover={{ scale:1.05, rotateX:5, rotateY:-5 }}
        transition={{ duration:0.6 }}
      >

        <img src="/assets/img/residential_home.jpeg" alt="Residential Solar" loading="lazy" decoding="async" />

        <div className="premium-overlay">
          <h3>Residential Solar Service</h3>
          <p>Smart rooftop solar solutions for homes</p>
        </div>

      </motion.div>
    </Link>


    <Link to="/services/commercial-solar" className="service-card-link">
      <motion.div
        className="premium-card"
        initial={{ opacity:0, y:60 }}
        whileInView={{ opacity:1, y:0 }}
        whileHover={{ scale:1.05, rotateX:5, rotateY:-5 }}
        transition={{ duration:0.6, delay:0.1 }}
      >

        <img src="/assets/img/commercial_home.jpeg" alt="Commercial Solar" loading="lazy" decoding="async" />

        <div className="premium-overlay">
          <h3>Commercial Solar</h3>
          <p>Reduce electricity costs for businesses</p>
        </div>

      </motion.div>
    </Link>


    <Link to="/services/industrial-solar" className="service-card-link">
      <motion.div
        className="premium-card"
        initial={{ opacity:0, y:60 }}
        whileInView={{ opacity:1, y:0 }}
        whileHover={{ scale:1.05, rotateX:5, rotateY:-5 }}
        transition={{ duration:0.6, delay:0.2 }}
      >

        <img src="/assets/img/industrial_home.jpeg" alt="Industrial Solar" loading="lazy" decoding="async" />

        <div className="premium-overlay">
          <h3>Industrial Solar</h3>
          <p>Large-scale energy systems for industries</p>
        </div>

      </motion.div>
    </Link>


    <Link to="/services/ground-mounted-solar" className="service-card-link">
      <motion.div
        className="premium-card"
        initial={{ opacity:0, y:60 }}
        whileInView={{ opacity:1, y:0 }}
        whileHover={{ scale:1.05, rotateX:5, rotateY:-5 }}
        transition={{ duration:0.6, delay:0.3 }}
      >

        <img src="/assets/img/groundmounted_home.jpeg" alt="Ground-Mounted Solar" loading="lazy" decoding="async" />

        <div className="premium-overlay">
          <h3>Ground-Mounted Solar</h3>
          <p>Utility-scale solar plants and solar farms</p>
        </div>

      </motion.div>
    </Link>

  </div>

        {/* ================= ADDITIONAL SERVICES ================= */}
      <section className="service-types-section">
        <div className="container">
          <div className="section-header">
            <h2 style={{ borderBottom: '3px solid #2E8B57', display: 'inline-block' }}>Additional Services</h2>
            <p>Explore our complementary renewable energy solutions</p>
          </div>
          <div className="additional-service-types-grid">
            <Link to="/solar-street-lights" className="service-type-card">
              <div className="service-type-image">
                <img src="/assets/img/solarLamp.jpeg" alt="Solar Street Lights" loading="lazy" />
              </div>
              <div className="service-type-content">
                <h3>Solar Street Lights</h3>
                <button className="service-type-btn">Learn More →</button>
              </div>
            </Link>

            <Link to="/solar-carport" className="service-type-card solar-carport-card">
              <div className="service-type-image">
                <img src="/assets/img/parkingSolar3.jpeg" alt="Solar Car Port Solutions" loading="lazy" />
              </div>
              <div className="service-type-content">
                <h3>Solar Car Port</h3>
                <button className="service-type-btn">Learn More →</button>
              </div>
            </Link>

            <Link to="/ev-charging-stations" className="service-type-card">
              <div className="service-type-image">
                <img src="/assets/img/charginEV.jpeg" alt="Solar EV Charging Station" loading="lazy" />
              </div>
              <div className="service-type-content">
                <h3>Solar EV Charging Station</h3>
                <button className="service-type-btn">Learn More →</button>
              </div>
            </Link>

            <Link to="/battery-energy-storage-system" className="service-type-card">
              <div className="service-type-image">
                <img src="/assets/img/battery2.jpeg" alt="Battery Energy Storage System (BESS)" loading="lazy" />
              </div>
              <div className="service-type-content">
                <h3>Battery Energy Storage System (BESS)</h3>
                <button className="service-type-btn">Learn More →</button>
              </div>
            </Link>
          </div>
        </div>
      </section>

</section>

      {/* <EnergyStats />
      <SolarProjects /> */}

      {/* ================= Solar EPC Process ================= */}

      {/* ================= SOLAR EPC PROCESS ================= */}

<section className="epc-process lazy-section">
  <div className="section-header">
    <h2 style={{ borderBottom: '3px solid #2E8B57', display: 'inline-block' }}>Solar EPC Execution Process</h2>
    <p>Our structured 7-step process ensures seamless project delivery</p>
  </div>

  <div className="process-grid">

    {[
      {
        step: "01",
        title: "Site Survey",
        desc: "Detailed on-site evaluation, shadow analysis and load assessment"
      },
      {
        step: "02",
        title: "Feasibility Analysis",
        desc: "Energy assessment, financial viability and ROI study"
      },
      {
        step: "03",
        title: "Engineering Design",
        desc: "Customized system design, layout planning and electrical SLD preparation"
      },
      {
        step: "04",
        title: "Procurement",
        desc: "Sourcing Tier-1 solar panels, inverters and mounting structures"
      },
      {
        step: "05",
        title: "Installation",
        desc: "Professional, safety-compliant structural and electrical installation"
      },
      {
        step: "06",
        title: "Commissioning",
        desc: "Complete system testing, grid connection and client handover"
      },
      {
        step: "07",
        title: "Performance Monitoring",
        desc: "Real-time monitoring, preventive maintenance and 24/7 support"
      }
    ].map((item, i) => (

      <motion.div
        key={i}
        className="process-card"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: i * 0.1 }}
        viewport={{ once: true }}
      >

        <div className="process-step">{item.step}</div>

        <h3>{item.title}</h3>

        <p>{item.desc}</p>

      </motion.div>

    ))}

  </div>
</section>


    
      {/* ================= WHY CHOOSE US ================= */}
 <section className="stats lazy-section">

  <h2 style={{ borderBottom: '3px solid #2E8B57', display: 'inline-block' }}>Why Choose V SQUARE RENEWABLES</h2>

  <div className="stats-grid">

    {[
      { icon: "⚙️", number: "Engineering Driven", label: "Every solar project is designed with strong mechanical engineering expertise to ensure maximum generation and long-term reliability" },
      { icon: "📋", number: "End-to-End EPC", label: "Complete project ownership from site survey and design to procurement, installation, and commissioning" },
      { icon: "📐", number: "Optimized Design", label: "Advanced system sizing, layout planning, and electrical optimization to maximize performance and ROI" },
      { icon: "⚡", number: "Quality Components", label: "Use of high-efficiency solar modules, reliable inverters, and durable mounting structures" },
      { icon: "🤝", number: "Transparent Communication", label: "Clear documentation, technical reporting, and client coordination throughout the project lifecycle" },
      { icon: "🔧", number: "O&M Support", label: "Preventive maintenance, performance monitoring, and plant health diagnostics with 24/7 support" },
      { icon: "✅", number: "Safety Compliance", label: "Adherence to electrical safety practices and industry installation standards" },
      { icon: "🌍", number: "Pan-India Services", label: "Professional solar EPC services across Maharashtra and throughout India" }
    ].map((stat, i) => (

      <motion.div
        key={i}
        className="stat-item"
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        transition={{ delay: i * 0.1 }}
      >
        <div className="stat-icon">{stat.icon}</div>
        <h3>{stat.number}</h3>
        <p>{stat.label}</p>

      </motion.div>

    ))}

  </div>

</section>

      {/* ================= COMPARISON TABLE ================= */}
      <section className="comparison-section lazy-section">
        <div className="section-header">
          <h2 style={{ borderBottom: '3px solid #2E8B57', display: 'inline-block', paddingBottom: '8px' }}>Why V SQUARE RENEWABLES Stands Out</h2>
          <p>See how we compare with other solar companies in the market</p>
        </div>

        <div className="comparison-table-wrapper">
          <table className="comparison-table">
            <thead>
              <tr>
                <th>Features</th>
                <th>V SQUARE RENEWABLES</th>
                <th>Others</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="feature-name">24/7 Monitoring</td>
                <td className="v-square">✓ Yes</td>
                <td>Limited</td>
              </tr>
              <tr>
                <td className="feature-name">Free Site Survey</td>
                <td className="v-square">✓ Yes</td>
                <td>✗ No</td>
              </tr>
              <tr>
                <td className="feature-name">Performance Guarantee</td>
                <td className="v-square">95-98% Uptime</td>
                <td>90-95%</td>
              </tr>
              <tr>
                <td className="feature-name">Subsidy Assistance</td>
                <td className="v-square">✓ Complete Help</td>
                <td>Partial Help</td>
              </tr>
              <tr>
                <td className="feature-name">O&M Services</td>
                <td className="v-square">✓ Comprehensive</td>
                <td>Basic</td>
              </tr>
              <tr>
                <td className="feature-name">Response Time</td>
                <td className="v-square">1-2 Hours</td>
                <td>4-6 Hours</td>
              </tr>
              <tr>
                <td className="feature-name">Customer Support</td>
                <td className="v-square">24/7 Dedicated</td>
                <td>Business Hours</td>
              </tr>
              <tr>
                <td className="feature-name">Custom Design Solutions</td>
                <td className="v-square">✓ Yes</td>
                <td>Limited</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="comparison-note">
          <p>💡 <strong>Note:</strong> V SQUARE RENEWABLES provides the most comprehensive solar solutions with the best value-for-money. Our commitment to quality, customer service, and performance sets us apart from competitors.</p>
        </div>
      </section>

      
      {/* ================= OUR COMMITMENT ================= */}
      <section className="features lazy-section">
        {/* <h2 style={{ borderBottom: '3px solid #2E8B57', display: 'inline-block' }}>Our Commitment to Excellence</h2> */}
        <div className="commitment-header">
      <h2>Our Commitment to Excellence</h2>
  </div>
        <div className="features-grid">
          {[
            ["⚡", "High Efficiency", "18–22% efficiency panels for maximum output"],
            ["🛡️", "Quality Assured", "International certified products and materials"],
            ["💰", "Cost Effective", "Government subsidy available and best pricing"],
            ["🌍", "Eco Friendly", "Help reduce your carbon footprint significantly"],
            ["🔧", "Expert Installation", "Professional engineers with proper training"],
            ["📞", "24/7 Support", "Always available support for our customers"],
          ].map((f, i) => (
            <motion.div
              key={i}
              className="feature-item"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
            >
              <div className="feature-icon">{f[0]}</div>
              <h3>{f[1]}</h3>
              <p>{f[2]}</p>
            </motion.div>
          ))}
        </div>
      </section>


      {/* ================= KEY BENEFITS ================= */}


          <section className="solar-benefits lazy-section">

  <div className="section-header">
    <h2 style={{ borderBottom: '3px solid #2E8B57', display: 'inline-block' }}>Key Benefits of Solar Power</h2>
  </div>

  <div className="benefits-grid">

    <div className="benefit-card">
      <span>⚡</span>
      <p>Reduce electricity costs by up to <strong>40–60%</strong></p>
    </div>

    <div className="benefit-card">
      <span>📈</span>
      <p>Protection against rising power tariffs</p>
    </div>

    <div className="benefit-card">
      <span>💰</span>
      <p>Long-term energy savings</p>
    </div>

    <div className="benefit-card">
      <span>🔧</span>
      <p>Low maintenance energy solution</p>
    </div>

    <div className="benefit-card">
      <span>🌍</span>
      <p>Environmentally sustainable power generation</p>
    </div>

  </div>

</section>



      {/* ================= NEWS & UPDATES ================= */}
      <section className="news-updates lazy-section">
        <div className="section-header">
          <h2 style={{ borderBottom: '3px solid #2E8B57', display: 'inline-block' }}>Latest News & Updates</h2>
          <p>Stay informed about government schemes, policy changes, and industry insights</p>
        </div>

        <div className="news-updates-grid">
          {[
            {
              icon: "📋",
              title: "PM-KUSUM Acceleration",
              desc: "Government fast-tracks subsidy disbursement for solar pump owners. Get up to 60% subsidy now.",
              category: "Government Scheme"
            },
            {
              icon: "🏛️",
              title: "New GST Rates",
              desc: "Solar panels now at 0% GST! Components reduced, making solar more affordable than ever.",
              category: "Policy Update"
            },
            {
              icon: "⚡",
              title: "Bifacial & Battery",
              desc: "Latest solar technology: 20% higher efficiency panels and smart battery storage systems.",
              category: "Technology"
            }
          ].map((item, i) => (
            <motion.div
              key={i}
              className="news-update-card"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
            >
              <div className="news-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
              <span className="news-category">{item.category}</span>
              <Link to="/news" className="news-link">Read More →</Link>
            </motion.div>
          ))}
        </div>

        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <Link to="/news" className="view-all-news">View All News & Articles</Link>
        </div>
      </section>

    <FAQ
  faqs={faqs}
  subtitle="Common questions about solar systems"
/>

      {/* ================= VIDEO BACKGROUND SECTION (Optional) ================= */}
      {/* <VideoBackground 
        title="Power Your Home with Clean Solar Energy"
        subtitle="Join thousands of satisfied customers who switched to renewable energy"
        overlayOpacity={0.5}
      >
        <div style={{ marginTop: '10px', display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/contact" className="cta-btn primary" style={{ textDecoration: 'none', color: 'white' }}>
            Get Your Free Assessment
          </Link>
          <Link to="/solar-calculator" className="cta-btn secondary" style={{ textDecoration: 'none' }}>
            See Your Savings
          </Link>
        </div>
      </VideoBackground> */}

    </div>
  );
};

export default Home;
